import React from 'react';
import {observer} from 'mobx-react';
import {FooterModuleDesktopContent} from "./footer-module.desktop.content";
import {FooterModuleBottom} from "../footer-module.bottom";
import {FooterModuleDesktopTop} from "./footer-module.desktop.top";
import classNames from "classnames";
import styles from "../../styles/footer.module.scss";

export const FooterModuleDesktop = observer(({controller, onItemClick}) => {
  const footerProps = {controller, onItemClick};
  const {state: {isAdVisible}} = controller;

  return (
    <div className={classNames(styles.content, { [styles.ads_visible]: isAdVisible })}>
      <FooterModuleDesktopTop controller={controller}/>
      <FooterModuleDesktopContent {...footerProps}/>
      <FooterModuleBottom controller={controller}/>
    </div>
  );
});
